import { render } from "./MoonEclipseClockView.vue?vue&type=template&id=2522e09a&scoped=true&ts=true"
import script from "./MoonEclipseClockView.vue?vue&type=script&lang=ts"
export * from "./MoonEclipseClockView.vue?vue&type=script&lang=ts"

import "./MoonEclipseClockView.vue?vue&type=style&index=0&id=2522e09a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2522e09a"]])

export default __exports__